import API from "..";

export default class WorkRequestPriority {

  constructor({
    priorityName,
    isActive,
    priorityLevel
  }) 
    
  {
    this.priorityName = priorityName;
    this.isActive = isActive;
    this.priorityLevel = priorityLevel
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get(`/workRequestPriority`);
    if (data.result) {
        return data.result.map((d) => new WorkRequestPriority(d));
    }
    else {
        return [];
    }
  }
}
